import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { forceCheck } from 'react-lazyload';
import './styles.scss';

import { redirect } from 'Helpers/Uri';

import Tab from 'Components/layout/Tab';

export default class Tabs extends Component {
    static propTypes = {
        children: PropTypes.any,
        alignTitles: PropTypes.oneOf(['left', 'center', 'right'])
    };
    static defaultProps = {
        alignTitles: 'center'
    };

    constructor(props) {
        super(props);

        this.state = {
            tabs: this.getTabs(props)
        };
    }

    getTabs = (props, forceActive = 0) => {
        let tabs = [];

        React.Children.map(props.children, (child, index) => {

            let active = false;
            if (forceActive) {
                if (forceActive === index) {
                    active = true;
                }
            } else {
                active = typeof child.props.active !== 'undefined' && child.props.active;
            }

            tabs.push({
                index: index,
                title: child.props.title,
                to: child.props.to,
                active: active,
                hidden: !(typeof child.props.hidden === 'undefined' || !child.props.hidden),
                element: child
            });
        });

        return tabs;
    }

    componentDidMount = () => {
        this.setState({
            ...this.state,
            tabs: this.getTabs(this.props)
        });
    }

    componentWillReceiveProps = props => {
        this.setState({
            ...this.state,
            tabs: this.getTabs(props)
        });
    }

    switchTab = tab => {
        //Hack to lazy load photos on tab change
        forceCheck();

        if (tab.to) {
            redirect(tab.to);
        } else {
            this.setState({
                ...this.state,
                tabs: this.getTabs(this.props, tab.index)
            });
        }
    }

    render() {
        const { tabs } = this.state;

        return (
            <div className="component-tabs">
                <header className={`tabs-header custom-scrollbar hidden align-titles-${this.props.alignTitles}`}>
                    {
                        tabs.map(tab => {
                            return (
                                tab.hidden ? null :
                                    <a key={tab.index} className={`tab-trigger  ${tab.active ? 'active' : ''}`} onClick={() => this.switchTab(tab)}>
                                        <h6 className="tab-title">{tab.title}</h6>
                                    </a>
                            );
                        })
                    }
                    <div className="border"></div>
                </header>
                <div className="tabs-wrapper">
                    {
                        tabs.map(tab => {
                            return (
                                <div key={tab.index} className={`tab-wrapper ${tab.active ? 'active' : ''}`}>
                                    {tab.element}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Tabs/index.js